<template>
  <div class="animated fadeIn">
    <div>
      <b-modal centered v-model="active" label="Delete" v-if="bookingToDelete">
        <div>Are you sure you want to delete this Booking?</div>
        <div slot="modal-footer">
          <b-btn ref="myModalRef" variant="danger" @click="handleDeleteConfirm">Confirm</b-btn>
          <b-btn @click="handleDeleteCancel">Cancel</b-btn>
        </div>
      </b-modal>
    </div>
    <div class="booking-list">
      <b-row class="my-2">
        <b-col md="12">
          <b-card header-tag="header">
            <div slot="header">
              <i class="fa fa-align-justify"></i>
              <strong>Filter</strong>
              <div class="card-actions">
                <b-dropdown variant="link" size="sm" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v fa-lg"></i>
                    <span class="sr-only">Options</span>
                  </template>
                  <b-dropdown-header>Bookings</b-dropdown-header>
                  <b-dropdown-item to="/bookings/add">Add Booking</b-dropdown-item>
                  <b-dropdown-item :href="reportURL" target="_blank">Download Report</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <b-row>
              <b-col lg="4">
                <v-input-date-range
                  label="Filter Bookings by Booking Date"
                  :from="filter.bookingDate.from"
                  @inputFrom="setFilterBookingFrom"
                  :to="filter.bookingDate.to"
                  @inputTo="setFilterBookingTo"
                  :disabled="isBusy"
                ></v-input-date-range>
              </b-col>
              <b-col lg="4">
                <v-input-date-range
                  label="Filter Bookings by Pick-up Date"
                  :from="filter.pickUpDate.from"
                  @inputFrom="setFilterPickupFrom"
                  :to="filter.pickUpDate.to"
                  @inputTo="setFilterPickupTo"
                  :disabled="isBusy"
                ></v-input-date-range>
              </b-col>
              <b-col lg="4">
                <b-form-group label="Filter by Agent">
                  <treeselect
                    :value="filter.agent"
                    @input="setFilterAgent"
                    :multiple="false"
                    :options="select2Agents"
                    placeholder="Filter by Agent"
                  />
                </b-form-group>
              </b-col>

            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-card class="p-0" no-body>
        <!--        <div slot="header">-->
        <!--          <b-row>-->
        <!--            <b-col>-->
        <!--              <b-form-group class="mb-0">-->
        <!--                <b-input-group>-->
        <!--                  <b-form-input-->
        <!--                    :value="filter.q"-->
        <!--                    :disabled="isBusy"-->
        <!--                    @blur.native="updateSearch"-->
        <!--                    @keyup.native="updateSearchOnEnterKey"-->
        <!--                    placeholder="Filter by client name"/>-->
        <!--                  <b-input-group-append>-->
        <!--                    <b-btn :disabled="!filter.q || isBusy" @click="filter.q = ''">Clear</b-btn>-->
        <!--                  </b-input-group-append>-->
        <!--                </b-input-group>-->
        <!--              </b-form-group>-->
        <!--            </b-col>-->
        <!--          </b-row>-->
        <!--        </div>-->

        <b-card-body class="p-0">
          <b-table
            ref="bookingTable"
            stacked="lg"
            :outlined="true"
            show-empty
            responsive
            class="border-0 m-0"
            :busy.sync="isBusy"
            :items="bookingProvider"
            :fields="fields"
            :filter="filterParams"
            :current-page="meta.current_page"
            :per-page="meta.per_page"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            hover
          >
            <template
              slot="pick_up_date"
              slot-scope="row"
            >{{ row.item.first_pick_up | moment('DD/MM/YYYY HH:mm') }}
            </template>
            <template slot="from" slot-scope="row">
              <span v-html="getPickUps(row.item.clients)"></span>
            </template>
            <template slot="to" slot-scope="row">
              <span v-html="getDropOffs(row.item.clients)"></span>
            </template>
            <template slot="fullnames" slot-scope="row">
              <span v-html="getFullnames(row.item.clients)"></span>
            </template>
            <template slot="persons" slot-scope="row">
              <span v-html="getPersons(row.item.clients)"></span>
            </template>
            <template slot="agent" slot-scope="row">{{ getAgentNameById(row.item.agent_id) }}</template>
            <template slot="total_inc_vat" slot-scope="row">&euro;{{ row.item.total_inc_vat }}</template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <div>
                  <pre>{{ row.item }}</pre>
                </div>
              </b-card>
            </template>
            <template slot="more" slot-scope="row">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-h fa-lg"></i>
                </template>
                <b-dropdown-item
                  :to="'/bookings/' + row.item.id + '/edit' + urlEncodedRedirect"
                >Edit Booking
                </b-dropdown-item>
                <b-dropdown-item-button @click="confirmDelete(row.item)">Delete Booking</b-dropdown-item-button>
                <b-dropdown-item :href="printURL(row.item.id)" target="_blank">Print</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card-body>
        <div class="pagination-container p-3 border-top">
          <b-row>
            <b-col class="text-right">
              <b-pagination
                align="right"
                class="my-0"
                :disabled="isBusy"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                v-model="meta.current_page"
              />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { bookingServices } from '../../services'
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { baseURL } from '../../axios'

export default {
  name: 'Bookings',
  params: ['agent_id'],
  components: {
    Treeselect
  },
  data () {
    return {
      active: false,
      bookingToDelete: null,
      links: {
        next: null,
        prev: null,
        first: null,
        last: null
      },
      meta: {
        current_page: null,
        from: null,
        to: null,
        last_page: null,
        path: null,
        per_page: null,
        total: null
      },
      isBusy: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: {
        q: '',
        bookingDate: {
          from: null,
          to: null
        },
        pickUpDate: {
          from: null,
          to: null
        },
        agent: null
      },
      fields: [
        { key: 'pick_up_date', label: 'Pick Up' },
        { key: 'trip_description', label: 'Trip Description' },
        { key: 'from', label: 'Pick Ups' },
        { key: 'to', label: 'Drop Offs' },
        { key: 'fullnames', label: 'Full Name' },
        { key: 'persons', label: 'Persons' },
        { key: 'agent', label: 'Agent' },
        { key: 'total_inc_vat', label: 'Price', class: 'text-right' },
        { key: 'more', label: '' }
      ]
    }
  },
  methods: {
    setAgentFilterById (agentId) {
      this.filter.agent = agentId
    },
    handleDeleteSuccess (res) {
      this.$refs.bookingTable.refresh()
      this.active = false
      console.log('Booking Deleted!')
    },
    handleDeleteConfirm () {
      let xhr = this.$store.dispatch(
        'bookings/destroy',
        this.bookingToDelete.id
      )
      xhr.then(this.handleDeleteSuccess).catch(this.handleDeleteFail)
    },
    handleDeleteFail () {
      this.isBusy = false
    },
    handleDeleteCancel () {
      this.active = false
    },
    confirmDelete (booking) {
      this.bookingToDelete = booking
      this.active = true
    },
    updateSearch (e) {
      this.filter.q = e.target.value
    },
    updateSearchOnEnterKey (e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.filter.q = e.target.value
      }
    },
    bookingProvider () {
      let filterParams = this.filterParams
      let params = {
        ...JSON.parse(filterParams),
        page: this.meta.current_page || 1
      }

      if (this.sortBy) {
        params.sort = this.sortBy
        if (this.sortDesc) {
          params.sort = params.sort + '-'
        }
      }

      let xhr = bookingServices.index(params)

      return xhr.then(
        this.handleBookingProviderSuccess,
        this.handleBookingProviderFail
      )
    },
    setLinks (links) {
      if (links) {
        this.$set(this.links, 'first', links.first)
        this.$set(this.links, 'last', links.last)
        this.$set(this.links, 'next', links.next)
        this.$set(this.links, 'prev', links.prev)
      }
    },
    setMeta (meta) {
      if (meta) {
        this.$set(this.meta, 'current_page', meta.current_page)
        this.$set(this.meta, 'from', meta.from)
        this.$set(this.meta, 'to', meta.to)
        this.$set(this.meta, 'last_page', meta.last_page)
        this.$set(this.meta, 'path', meta.path)
        this.$set(this.meta, 'per_page', meta.per_page)
        this.$set(this.meta, 'total', meta.total)
      }
    },
    handleBookingProviderSuccess (res) {
      if (res.hasOwnProperty('data')) {
        this.setLinks(res.data.hasOwnProperty('links') ? res.data.links : null)
        this.setMeta(res.data.hasOwnProperty('meta') ? res.data.meta : null)

        return res.data.hasOwnProperty('data') ? res.data.data : []
      } else {
        return []
      }
    },
    handleBookingProviderFail (e) {
      console.log(e.response)
    },
    getAgentNameById (agentId) {
      let agent = this.agentById(agentId)
      return agent ? agent.name : ''
    },
    getLocationNameById (locationId) {
      let location = this.locationById(locationId)
      return location ? location.name : ''
    },
    getDropOffs (clients) {
      let out = []
      var client
      for (client of clients) {
        let location = this.locationById(client.drop_off_location)
        if (location) {
          out.push(location.name)
        }
      }
      return out.join('<br> ')
    },
    getPickUps (clients) {
      let out = []
      var client
      for (client of clients) {
        let location = this.locationById(client.pick_up_location)
        if (location) {
          out.push(location.name)
        }
      }
      return out.join('<br> ')
    },
    getFullnames (clients) {
      let out = []
      var client
      for (client of clients) {
        out.push(client.full_name)
      }
      return out.join('<br> ')
    },
    getPersons (clients) {
      let out = []
      var client
      for (client of clients) {
        out.push(client.persons)
      }
      return out.join('<br> ')
    },
    printURL (bookingId) {
      let url = bookingServices.printURL(bookingId)
      return url + '?token=' + this.accessToken
    },
    setFilterBookingFrom (from) {
      this.updateFilters({ bookingFrom: from })
    },
    setFilterBookingTo (to) {
      this.updateFilters({ bookingTo: to })
    },
    setFilterPickupFrom (from) {
      this.updateFilters({ pickupFrom: from })
    },
    setFilterPickupTo (to) {
      this.updateFilters({ pickupTo: to })
    },
    setFilterAgent (agent) {
      this.updateFilters({ agent: agent })
    },
    updateFilters (newFilters) {
      let filters = Object.assign({}, this.$route.query)
      filters = Object.assign(filters, newFilters)
      this.$router.push({ path: '/bookings/list', query: filters })
    },
    updateFiltersByQuery () {
      this.filter.bookingDate.from = this.$route.query.bookingFrom
      this.filter.bookingDate.to = this.$route.query.bookingTo

      this.filter.pickUpDate.from = this.$route.query.pickupFrom
      this.filter.pickUpDate.to = this.$route.query.pickupTo

      this.filter.agent = this.$route.query.agent
    }
  },
  computed: {
    ...mapGetters('user', ['accessToken']),
    ...mapGetters('agents', ['agents', 'agentById', 'select2Agents']),
    ...mapGetters('locations', ['locationById']),
    reportURL () {
      let _filters = JSON.parse(this.filterParams)
      let url = baseURL + 'booking/report'
      url += '?token=' + this.accessToken
      if (_filters.bookingDate) {
        url += '&bookingDate=' + _filters.bookingDate
      }
      if (_filters.pickUpDate) {
        url += '&pickUpDate=' + _filters.pickUpDate
      }
      if (_filters.agents) {
        for (let agent of _filters.agents) {
          url += '&agents[]=' + agent
        }
      }

      return url
    },
    filterParams () {
      let params = {
        sort: ''
      }

      if (this.filter.q) {
        params.fullName = this.filter.q.toLowerCase()
      }

      if (this.$route.query.agent) {
        params.agents = [this.$route.query.agent]
      }

      if (this.$route.query.bookingFrom && this.$route.query.bookingTo) {
        params.bookingDate =
          this.$route.query.bookingFrom + ',' + this.$route.query.bookingTo
      }

      if (this.$route.query.pickupFrom && this.$route.query.pickupTo) {
        params.pickUpDate =
          this.$route.query.pickupFrom + ',' + this.$route.query.pickupTo
      }

      return JSON.stringify(params)
    },
    urlEncodedRedirect () {
      return '?redirect=' + encodeURIComponent(this.$route.fullPath)
    }
  },
  created () {
    this.$store.dispatch('locations/index')
    this.$store.dispatch('travelAgents/index')
    this.$store.dispatch('agents/index')
    if (this.$route.params.hasOwnProperty('agent_id')) {
      this.filter.agent = parseInt(this.$route.params.agent_id)
    }
  },
  mounted () {
    this.updateFiltersByQuery()
  },
  watch: {
    $route (to) {
      this.updateFiltersByQuery()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/bookings/Index.vue